export default __webpack_public_path__ + "static/media/appartamenti.9174288f.svg";